module.exports = __webpack_public_path__ + "img/文本art.a7ba728b.png";